import { styled } from '@flex-design-system/stitches-react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ScrollArea } from '../../../scroll-area/ScrollArea.mjs';

const StyledContent_Legacy = styled(DialogPrimitive.Content);
const StyledScrollAreaViewport_Legacy = styled(
  ScrollArea.Viewport_Legacy
);

export { StyledContent_Legacy, StyledScrollAreaViewport_Legacy };
//# sourceMappingURL=styled.mjs.map
